
import './Welcome.css';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { STAKEHOLDER_LOGIN_URL, USER_LOGIN_URL } from '../common/URLs';
import { LINKS, NEWS, NEWS_CONTENT } from '../common/constants';
import { ExpandMore as ExpandMoreIcon, ArrowUpward as ArrowUpwardIcon, Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Localization from '../common/common-localization/localization';
import abeplLogo from "../images/abeplLogo.png";

function Welcome() {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.resolvedLanguage === 'as' ? NEWS_CONTENT : NEWS;
  const Auth_Code = localStorage.getItem('auth_code');
  const stakeholderData = [
    {
      sNo: t('main.one'),
      title: t('main.farmersTitle'),
      content: t('main.farmersContent')
    },
    {
      sNo: t('main.two'),
      title: t('main.hitTitle'),
      content: t('main.hitContent')
    },
    {
      sNo: t('main.three'),
      title: t('main.lleTitle'),
      content: t('main.lleContent')
    },
    {
      sNo: t('main.four'),
      title: t('main.transporterTitle'),
      content: t('main.transporterContent')
    }
  ]
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      if (window.location.href == window.location.origin) {
        window.location.href = window.location.origin;
        window.history.pushState(null, "", window.location.href);
      }
    };
  }, []);

  useEffect(() => {
    if (Auth_Code) {
      navigate("/spinLoader");
    }
  }, [Auth_Code]);

  var loc = window.location.href
  let paramIsPresent = loc.search("param");
  let param = loc.slice(paramIsPresent + 6)

  useEffect(() => {
    if (param === "PreReg") {
      localStorage.setItem('loginStatus', "preReg")
      navigate("/WebRegSidebar")
    }
    else if (param === "CheckStatus") {
      localStorage.setItem('loginStatus', "checkStatus")
      navigate("/CheckApplicationStatus")
    }
    else if (param === "Publicfaqs") {
      localStorage.setItem('loginStatus', "Publicfaqs")
      navigate("/Publicfaqs")
    }
    else if (param === "GuestUser") {
      localStorage.setItem('loginStatus', "GuestUser")
      navigate("/GuestUserSignUp")
    }
    else if (param === "UserForgotPassword") {
      localStorage.setItem('loginStatus', "UserForgotPassword")
      navigate("/forgotPasswordscreen/abrpluser")
    }
    else if (param === "StakeForgotPassword") {
      localStorage.setItem('loginStatus', "UserForgotPassword")
      navigate("/forgotPasswordscreen/stakeholder")
    }
  }, [param]);

  const [menuShow, setMenuShow] = useState(true)

  const handleMenuClick = () => {
    setMenuShow(!menuShow)
    const navbar = document.querySelector('#navbar');
    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    if (navbar && mobileNavToggle) {
      navbar.classList.toggle('navbar-mobile');
      mobileNavToggle.classList.toggle('bi-list');
      mobileNavToggle.classList.toggle('bi-x');
    }
  };

  const [dropdownClicked, setDropdownClicked] = useState(false)

  const handleDropdownClick = (event) => {
    setDropdownClicked(!dropdownClicked)
  }

  const scrollto = (el) => {
    let header = document.querySelector('#header')
    let offset = header.offsetHeight

    if (!header.classList.contains('header-scrolled')) {
      offset -= 16
    }

    let elementPos = document.querySelector(el).offsetTop
    window.scrollTo({
      top: elementPos - offset,
      behavior: 'smooth'
    })
  }

  const handleAboutClick = () => {
    let navbar = document.querySelector('#navbar')
    if (navbar.classList.contains('navbar-mobile')) {
      navbar.classList.remove('navbar-mobile')
      let navbarToggle = document.querySelector('.mobile-nav-toggle')
      navbarToggle.classList.toggle('bi-list')
      navbarToggle.classList.toggle('bi-x')
    }
    scrollto(this.hash)
  }

  return (
    <div>
      <header id="header" className="d-flex align-items-center">
        <div className="container d-flex align-items-center">
          <h1 class="logo me-auto"><a href="" style={{ display: "flex", alignItems: "center" }}>
            <img src={abeplLogo} />
            &nbsp; &nbsp;
            <p style={{ marginBottom: "0vh" }}>{t("main.header")}</p></a></h1>
          <nav id="navbar" className="navbar">
            <ul>
              <li><a className="nav-link scrollto active" href="#hero">{t("main.home")}</a></li>
              <li><a onClick={handleAboutClick} className="nav-link scrollto" href="#about">{t('main.about')}</a></li>
              <li><a className="nav-link scrollto" href="#services">{t('main.services')}</a></li>
              <li><a className="nav-link scrollto " href="#portfolio">{t("main.portfolio")}</a></li>
              <li><a className="nav-link scrollto" href="#team">{t('main.contact')}</a></li>
              <li className="dropdown">
                <a onClick={handleDropdownClick} href="#">
                  <span>{t('main.login')}</span>
                  <ExpandMoreIcon />
                </a>
                <ul className={dropdownClicked && 'dropdown-active'}>
                  <li><a href={USER_LOGIN_URL}>{t('main.abeplLogin')}</a></li>
                  <li><a href={STAKEHOLDER_LOGIN_URL + "&lang=" + localStorage.getItem("i18nextLng")}>{t('main.userLogin')}</a></li>
                </ul>
              </li>
              <li><a className="getstarted scrollto" href={window.location.origin + "/?param=PreReg"}>{t('main.register')}</a></li>
              <li><Localization /></li>
            </ul>
            {menuShow ? <MenuIcon onClick={handleMenuClick} className="bi bi-list mobile-nav-toggle" /> : <CloseIcon onClick={handleMenuClick} className="bi bi-x mobile-nav-toggle" />}
          </nav>
        </div>
      </header>
      <section id="hero">
        <div id="heroCarousel" data-bs-interval="5000" className="carousel slide carousel-fade" data-bs-ride="carousel">
          <div className="carousel-inner" role="listbox">
            <div className="carousel-item active" style={{ backgroundImage: "url(" + window.location.origin + "/static/media/bamboo2.2dadf25a92e6e15d6472.jpg" + ")" }}>
              <div className="carousel-container">
                <div className="container">
                  <h2 className="animate__animated animate__fadeInDown">{i18n.resolvedLanguage === 'as' ? t('main.abepl') : t('main.welcome')} <span>{i18n.resolvedLanguage === 'as' ? t('main.welcome') : t('main.abepl')}</span></h2>
                  <a href="#about" className="btn-get-started animate__animated animate__fadeInUp scrollto">{t('main.readmore')}</a>
                </div>
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
            <span className="carousel-control-prev-icon bi bi-chevron-left" aria-hidden="true"></span>
          </a>
          <a className="carousel-control-next" href="#heroCarousel" role="button" data-bs-slide="next">
            <span className="carousel-control-next-icon bi bi-chevron-right" aria-hidden="true"></span>
          </a>
        </div>
      </section>
      <section style={{ padding: "10px 0" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-between align-items-center breaking-news bg-white">
              <div className="d-flex flex-row flex-grow-1 flex-fill justify-content-center bg-danger py-2 text-white px-1 news"><span className="d-flex align-items-center">&nbsp;{t('main.news')}</span></div>
              <marquee className="news-scroll" behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
                {
                  selectedLanguage.map((item) => {
                    return (
                      <>
                        <a href="#">{item}</a> <span className="dot"></span>
                      </>
                    )
                  })
                }
              </marquee>
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section id="cta" className="cta">
          <div className="container">

            <div className="row">
              <div className="col-lg-9 text-center text-lg-start" style={{ display: "flex", alignItems: "center" }}>
                <h3>{t('main.status')}</h3>
              </div>
              <div className="col-lg-3 cta-btn-container text-center">
                <a className="cta-btn align-middle" href={window.location.origin + "/?param=CheckStatus"}>{t("main.check")}</a>
              </div>
            </div>

          </div>
        </section>
        <section id="about" className="about">
          <div className="container">
            <div className="section-title">
              <h2>{t("main.aboutUs")}</h2>
              <p style={{ textAlign: "justify" }}>{t('main.para1')}</p>
            </div>
            <p style={{ textAlign: "justify" }}><i className="bi bi-check-circled"></i>{t('main.para2')}</p>
            <div className="row">
              <div className="col-lg-6 order-1 order-lg-2">
                <img src="assets/img/homePage.png" className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 content">
                <p style={{ textAlign: "justify" }}><i className="bi bi-check-circled"></i>{t('main.para3')}</p>
              </div>
            </div>
            <p style={{ textAlign: "justify", marginTop: "3vh" }}>
              {t('main.para4')}
            </p>
          </div>
        </section>
        <section id="why-us" className="why-us">
          <div className="container">
            <div className="row no-gutters">
              {stakeholderData.map((item) => {
                return (
                  <div className="col-lg-6 col-md-6 content-item">
                    <span>{item.sNo}</span>
                    <h4>{item.title}</h4>
                    <p style={{ textAlign: "justify" }}>{item.content}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </section>



      </main>
      <footer id="footer">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-10 col-lg-8 mx-auto">
              <div className="row g-4 justify-content-between text-start">
                <div className="col-12 col-md-5 text-start" style={{ marginLeft: "-150px" }}>
                  <h6>{t('main.officeAddressTitle')}:</h6>
                  <p>
                    {t('main.abeplName')}<br />
                    {t('main.abeplAdd1')}<br />
                    {t('main.abeplAdd2')}<br />
                    {t('main.abeplpin')}<br />

                  </p>
                </div>
                <div className="col-12 col-md-6" style={{ marginRight: "-150px" }}>
                  <h6> {t('main.siteOfficeTitle')}:</h6>
                  <p>
                    {t('main.abeplName')}<br />
                    {t('main.siteAdd1')}<br />
                    {t('main.siteAdd2')}<br />
                    {t('main.sitepin')}<br />
                    {t('main.email')}: scm@abepl.co.in<br />
                    {t('main.siteContact')}
                  </p>
                </div>
              </div>
              {/* <div className="col-lg-4" style={{ textAlign: 'left' }}>
              <h6> {t('main.contactNos')}:</h6>
              <p>
                {t('main.contact1')}<br />
                {t('main.contact2')}<br />
                {t('main.contact3')}<br />
                {t('main.contact4')}<br />
              </p>
            </div> */}
            </div>
          </div>
          <div className="social-links">
            <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
            <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
            <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
            <a href="#" className="google-plus"><i className="bx bxl-skype"></i></a>
            <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a>
          </div>
          <div className="copyright" style={{ fontWeight: "600" }}>
            <a style={{ color: "white" }} href={LINKS.TERMS_OF_USE}>{t('main.terms')}</a> &nbsp; &nbsp;
            <a style={{ color: "white" }} href={LINKS.PRIVACY_POLICY}>{t('main.privacy')}</a>
          </div>
          <div className="copyright">
            &copy; {t('main.copyright')} <strong><span>{t('main.abepl')}</span></strong>. {t('main.allrightsReserved')}
          </div>
          <div className="credits">
          </div>
        </div>
      </footer>
      <a style={{ color: "white" }} href="#" class="back-to-top d-flex align-items-center justify-content-center active">
        <ArrowUpwardIcon />
      </a>
    </div>
  );
}

export default Welcome;
